export const PAP_NAMESPACES = {
  FINAL_RESULTS: 'Final Income Results',
  APPLICATION_RESULTS: 'Application Results',
  HOUSEHOLD_SIZE: 'Household Size',
  ANNUAL_HOUSEHOLD_INCOME: 'Annual Household Income',
  FPL_PERCENTAGE: 'FPL %',
  POI_RESULTS: 'POI Results',
  APPLICATION_HOUSEHOLD_INCOME_INFORMATION:
    'Application Household Income Information',
  APPLICATION_HOUSEHOLD_SIZE: 'Application Household Size',

  NO_LAYOUT_FOUND: 'No Layout Found',
  LOADING: 'Loading...',

  SELECT_PRIORITY: 'Select Priority',
  PROOF_OF_INCOME: 'Proof of Income',
  EXPERIAN: 'Experian',
  EXPERIAN_UPPERCASE: 'EXPERIAN',
  POI_UPPERCASE: 'POI',

  CAPTURE_API_RESPONSE: 'Capture API Response',
  NO_DATA: 'No Data',
  API_DETAILS: 'API Details',
  INTEGRATION_NAME: 'Integration Name',
  ATTEMPT_COUNT: 'Attempt Count',
  STATUS: 'Status',
  MODIFIED_BY: 'Modified By',
  CREATED_AT: 'Created At',
  ERROR: 'Error',

  VIEW_RESPONSE: 'View Response',
  RESPONSE: 'Response',
  DATA_ADDED_SUCCESSFULLY: 'Data Added Successfully',
  LOADING_DATA: 'Loading data...',
  NO_GENERIC_PAYLOAD_RECORDS_FOUND: 'No generic payload records found',
}
export const NPI_STATUS_CUSTOM_LAYOUT = {
  PROVIDER_NPI_STATUS_KEY: 'provider_npi_status',
  PROVIDER_NPI_STATUS_LABEL: 'PROVIDER NPI STATUS',
}

export const NPI_STATUS_TABLE_COLUMNS = [
  {
    header: 'Error Message',
    accessor: 'response_error_message',
    isHidden: false,
  },
  {
    header: 'Created At',
    accessor: 'created_at',
    isHidden: false,
  },
  {
    header: 'Group ID',
    accessor: 'group_id',
    isHidden: true,
  },
  {
    header: 'Case ID',
    accessor: 'case_id',
    isHidden: true,
  },
]
export const PAP_CONSTANTS = {
  HOUSEHOLD_SIZE_FINAL: 'household_size_final',
  ANNUAL_INCOME_FINAL: 'annual_income_final',
  FPL_PERCENTAGE_FINAL: 'fpl_percentage_final',

  HOUSEHOLD_SIZE_POI: 'household_size_poi',
  ANNUAL_INCOME_POI: 'annual_income_poi',
  FPL_PERCENTAGE_POI: 'fpl_percentage_poi',

  HOUSEHOLD_SIZE_APPLICATION: 'household_size_application',
  ANNUAL_INCOME_ON_APPLICATION: 'annual_income_on_application',
  FPL_PERCENTAGE_APPLICATION: 'fpl_percentage_application',

  POI: 'poi',
  EXPERIAN: 'experian',

  INTEGRATION_NAME: 'integration_name',
  ATTEMPT_COUNT: 'attempt_count',
  STATUS: 'status',
  HTTP_STATUS: 'http_status',
  MODIFIED_BY: 'modified_by',
  CREATED_AT: 'created_at',
  RESPONSES: 'responses',
  ERROR: 'error',
  REVIEW_REQUEST: 'reviewRequest',
  DISCOVERY_DATA: 'discoveryData',
  BV_CASES: 'bvCases',
  INSURANCE_INFO: 'insuranceInfo',
  LIS_INFO: 'LISInfo',
  CASE_PAP_DETAILS: 'casePAPDetails',
  E_VERIFICATION: 'eVerification',
} as const

export const REVIEW_REQUEST_CUSTOM_LAYOUT = {
  REVIEW_COMPLETED_LABEL: 'Review Completed',
  DECISION_LABEL: 'Decision of Review',
  REASON_LABEL: 'Appeal Reason',
  SUMMARY_LABEL: 'Appeal Summary',
  REVIEW_COMPLETED_KEY: 'review_completed',
  DECISION_KEY: 'decision_of_review',
  REASON_KEY: 'appeal_reason',
  SUMMARY_KEY: 'appeal_summary',
  REVIEW_COMPLETED_OPTIONS: [
    {
      label: 'Yes',
      value: 117,
    },
    {
      label: 'No',
      value: 118,
    },
  ],
  DECISION_OPTIONS: [
    {
      label: 'Deny Request',
      value: 3708,
    },
    {
      label: 'Send Request for Approval',
      value: 3709,
    },
  ],
  REASON_OPTIONS: [
    {
      label: 'Acceptable Document',
      value: 'Acceptable Document',
    },
    {
      label: 'Application Version',
      value: 'Application Version',
    },
    {
      label: 'Clinical Trial Patient',
      value: 'Clinical Trial Patient',
    },
    {
      label: 'Diagnosis',
      value: 'Diagnosis',
    },
    {
      label: 'Facility Banned List',
      value: 'Facility Banned List',
    },
    {
      label: 'Healthcare Facility Location',
      value: 'Healthcare Facility Location',
    },
    {
      label: 'Income',
      value: 'Income',
    },
    {
      label: 'Insurance Cost Share',
      value: 'Insurance Cost Share',
    },
    {
      label: 'Insurance Status',
      value: 'Insurance Status',
    },
    {
      label: 'Low Income Subsidy (LIS)',
      value: 'Low Income Subsidy (LIS)',
    },
    {
      label: 'Medicaid Eligibility',
      value: 'Medicaid Eligibility',
    },
    {
      label: 'Patient Age',
      value: 'Patient Age',
    },
    {
      label: 'Place of Service / HealthCare Facility Type',
      value: 'Place of Service / HealthCare Facility Type',
    },
    {
      label: 'Product Coverage',
      value: 'Product Coverage',
    },
    {
      label: 'Proof of Residency',
      value: 'Proof of Residency',
    },
    {
      label: 'Provider Banned List',
      value: 'Provider Banned List',
    },
    {
      label: 'Provider NPI',
      value: 'Provider NPI',
    },
    {
      label: 'Provider Title',
      value: 'Provider Title',
    },
    {
      label: 'Re-enrolment Too Soon',
      value: 'Re-enrolment Too Soon',
    },
    {
      label: 'Residency',
      value: 'Residency',
    },
    {
      label: 'Supported Product',
      value: 'Supported Product',
    },
  ],
}

export const PAP_APPEAL_TASK_STRINGS = {
  REVIEW_APPEAL_REQUEST: 'Review Appeal Request',
  DISCOVERY_DATA: 'Discovery Data',
  BV_CREATED_CASE: 'BV Created Case',
}

export const NPI_STATUS_CONSTANTS = {
  CASE_PAP_DETAILS_ENTITY_ID: 596147,
  CASE_ENTITY_NAME: 'case',
  CASE_ENTITY_ID: 32,
  PROVIDERS_ENTITY_NAME: 'c_providers',
  PROVIDERS_ENTITY_ID: 4,
  ENTITY_FIELDS_ENTITY_NAME: 'd_entity_fields',
  ENTITY_FIELDS_ENTITY_ID: '2259',
  GENERIC_PAYLOAD_ENTITY_NAME: 'generic_payload',
  GENERIC_PAYLOAD_GROUP_ID: '4',
  CASE_PAP_DETAILS_ENTITY_NAME: 'case_pap_details',

  FIELD_PROVIDER_NPI_STATUS: 'provider_npi_status',
  FIELD_PROVIDER_ID: 'provider_id',
  FIELD_NPI: 'npi',
  FIELD_NAME: 'field_name',
  FIELD_D_ENTITY_ID: 'd_entity_id',
  FIELD_GROUP_ID: 'group_id',
  FIELD_CASE_ID: 'case_id',

  ENTITY_FIELDS_SELECT: ['id', 'field_name', 'd_entity_id', 'control_values'],
  GENERIC_PAYLOAD_SELECT: [
    'response_error_message',
    'created_at',
    'group_id',
    'case_id',
  ],

  DATE_FORMAT: 'MM/DD/YYYY HH:mm A',

  ACCORDION_HEADING: 'NPI Status',
  PROVIDER_NPI_LABEL: 'Provider NPI #',

  ERROR_UPDATE_FAILED: 'Failed to update NPI status',

  OPERATION_EQUALS: 'EQUALS',
  LOGICAL_OPERATOR_AND: 'AND',
}
